import type * as v from 'valibot';
import type {
  buildSortPlansPayloads,
  Sf0726LoanInput,
} from 'tio-common/utils/strategy-finder-0726';
import {
  buildFe0726Payloads,
  fe0726AnswerProfileUpdates,
  fe0726FormSchema,
  REQUESTING_APP as FE_REQUESTING_APP,
} from 'tio-employee/utils/forgiveness-estimator-0726';
import {
  buildIdr0726Payloads,
  idr0726AnswerProfileUpdates,
  idr0726FormSchema,
  REQUESTING_APP as IDR_REQUESTING_APP,
  type Idr0726FormModel,
} from 'tio-employee/utils/idr-dashboard-0726';

/** Every answer the questionnaire can collect; a variant ignores the ones it does not ask. */
export type Questionnaire0726FormModel = Idr0726FormModel;

/** One flavour of the 0726 questionnaire. */
export interface Questionnaire0726Variant {
  /** Middle of every `data-test-<prefix>-*` attribute the form renders, e.g. `idr-0726`. */
  testPrefix: string;
  /** App key the recommendation is saved under and the answer profile is written for. */
  requestingApp: string;
  /** Validates the answers before anything is saved. */
  schema: v.GenericSchema;
  /** Turns the answers and loan cards into the recommendation's calculation input. */
  buildPayloads: (
    model: Questionnaire0726FormModel,
    loanInputs: Sf0726LoanInput[]
  ) => ReturnType<typeof buildSortPlansPayloads>;
  /** The answer-profile fields to persist after a successful save. */
  answerProfileUpdates: (model: Questionnaire0726FormModel) => Record<string, unknown>;
  /** Whether the "can you afford your payments" question is asked (and prefilled). */
  asksAffordPayments: boolean;
}

export const FORGIVENESS_ESTIMATOR_0726: Questionnaire0726Variant = {
  testPrefix: 'fe-0726',
  requestingApp: FE_REQUESTING_APP,
  schema: fe0726FormSchema,
  buildPayloads: buildFe0726Payloads,
  answerProfileUpdates: fe0726AnswerProfileUpdates,
  asksAffordPayments: false,
};

export const IDR_DASHBOARD_0726: Questionnaire0726Variant = {
  testPrefix: 'idr-0726',
  requestingApp: IDR_REQUESTING_APP,
  schema: idr0726FormSchema,
  buildPayloads: buildIdr0726Payloads,
  answerProfileUpdates: idr0726AnswerProfileUpdates,
  asksAffordPayments: true,
};
